// extracted by mini-css-extract-plugin
export var closeButton = "_72-0";